module.exports = __webpack_public_path__ + "media/images/application/template/arrow-left-440b91589278383e5d47c5f7b52086bc.svg";